import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';

import { Account } from 'app/core/models';
import { Project } from 'app/modules/projects/projects.types';
import { PanelsInterfaceComponent, PanelsInterfaceComponentBase } from '../panels-interface.component';
import { RelatedToType } from 'app/shared/enums';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableComponent extends PanelsInterfaceComponentBase implements PanelsInterfaceComponent, OnInit {
  @Input() account: Account;
  @Input() project: Project;
  @Input() readonly = false;
  @Output() onEditPanelDef: EventEmitter<any> = new EventEmitter();

  relatedToTypeProject = RelatedToType.Project;

  constructor(protected readonly changeDetectorRef: ChangeDetectorRef) {
    super(changeDetectorRef);
  }

  ngOnInit(): void {
    this.titleFieldDef = {
      name: 'table.panel_name',
      label: this.panelDef.title,
      type: 'text',
    };
  }

  onEditPanel(event): void {
    this.onEditPanelDef.emit(event);
  }
}
